/* =========================================================
   FILE: cn-contact.js
   Formularvalidierung + FAQ.
========================================================= */

(() => {
  'use strict';

  const initialized = new WeakSet();

  const initialize = (root) => {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const contactForm = root.querySelector('#ContactForm');
    const topicSelect = root.querySelector('#ContactForm-topic');
    const topicField = topicSelect ? topicSelect.closest('.cn-contact__field--select') : null;
    const orderInput = root.querySelector('#ContactForm-order');
    const emailInput = root.querySelector('#ContactForm-email');
    const messageInput = root.querySelector('#ContactForm-body');
    const faqItems = root.querySelectorAll('.cn-contact__faq-item');

    function updateTopicState() {
      if (!topicSelect || !topicField) return;

      if (topicSelect.value) {
        topicField.classList.add('is-selected');
      } else {
        topicField.classList.remove('is-selected');
      }
    }

    function validateTopic() {
      if (!topicSelect) return;

      topicSelect.setCustomValidity(
        topicSelect.value ? '' : 'Bitte wähle ein Anliegen aus.'
      );

      updateTopicState();
    }

    function normalizeOrderNumber() {
      if (!orderInput) return;

      orderInput.value = orderInput.value.replace(/\D/g, '');
    }

    function validateEmail() {
      if (!emailInput) return;

      if (emailInput.validity.valueMissing) {
        emailInput.setCustomValidity('Bitte gib deine E-Mail-Adresse ein.');
      } else if (emailInput.validity.typeMismatch) {
        emailInput.setCustomValidity('Bitte gib eine gültige E-Mail-Adresse ein.');
      } else {
        emailInput.setCustomValidity('');
      }
    }

    function validateMessage() {
      if (!messageInput) return;

      messageInput.setCustomValidity(
        messageInput.value.trim() ? '' : 'Bitte gib eine Nachricht ein.'
      );
    }

    if (topicSelect) {
      updateTopicState();
      topicSelect.addEventListener('invalid', validateTopic);
      topicSelect.addEventListener('change', validateTopic);
      topicSelect.addEventListener('input', validateTopic);
    }

    if (orderInput) {
      orderInput.addEventListener('input', normalizeOrderNumber);
      orderInput.addEventListener('blur', normalizeOrderNumber);
      orderInput.addEventListener('change', normalizeOrderNumber);
      orderInput.addEventListener('paste', function () {
        window.requestAnimationFrame(normalizeOrderNumber);
      });
    }

    if (emailInput) {
      emailInput.addEventListener('invalid', validateEmail);
      emailInput.addEventListener('input', validateEmail);
      emailInput.addEventListener('change', validateEmail);
    }

    if (messageInput) {
      messageInput.addEventListener('invalid', validateMessage);
      messageInput.addEventListener('input', validateMessage);
      messageInput.addEventListener('change', validateMessage);
    }

    if (contactForm) {
      contactForm.addEventListener('submit', function (event) {
        validateTopic();
        normalizeOrderNumber();
        validateEmail();
        validateMessage();

        if (!contactForm.checkValidity()) {
          event.preventDefault();
          contactForm.reportValidity();
        }
      });
    }

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        faqItems.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.open = false;
          }
        });
      });
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('.cn-contact')) initialize(scope);
    scope.querySelectorAll?.('.cn-contact').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
